import { bindActionCreators } from 'redux';
import State from '@wfp-root-app/store/state';
import { connect } from 'react-redux';

import AsyncTasksPage from './AsyncTasksPage';
import { ManagerPermission } from '../../permission-profiles/permission';
import { ActionCreators as AsyncActionCreators, AsyncTasksTypes } from '../../utils/asyncTasks';
import { ActionCreators as BeneficiaryActionCreators } from '../beneficiaries';
import { hasFeatureAccess } from '../../login/auth';
import AsyncTasksListView from '../AsyncTasksListView';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapDispatchToProps(dispatch: any) {
    return {
        authorizeTask: bindActionCreators(AsyncActionCreators.authorizeAsyncTask, dispatch),
        downloadFile: bindActionCreators(AsyncActionCreators.downloadFile, dispatch),
        loadAsyncTasksList: (page, limit) =>
            dispatch(AsyncActionCreators.loadAsyncTasksList(page, limit, AsyncTasksTypes.IMPORT_BENEFICIARIES)),
        uploadFile: (
            data: File,
            dryRun?: boolean,
            mapping?: Record<number, string>,
            dryRunAsyncTaskId?: string,
            additionalData: Record<string, unknown> = {}
        ) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const params: any = {
                data,
                mapping,
                startIndex: 2,
                schedule: !dryRun,
                ...additionalData,
            };
            if (dryRun) {
                params.dryRun = true;
            }
            if (dryRunAsyncTaskId) {
                params.dryRunAsyncTaskId = dryRunAsyncTaskId;
            }
            return dispatch(BeneficiaryActionCreators.importBeneficiaries(params));
        },
        clearUploadTask: bindActionCreators(BeneficiaryActionCreators.clearUploadTask, dispatch),
    };
}

function mapStateToProps(state: State, _ownProps) {
    const canImport = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesEntitlementPark);
    const canAuthorizeTask = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesEntitlementVerify);
    const canDownload = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesDownload);

    return {
        canPark: canImport && state?.auth?.manager?.agency !== 'ALL',
        canPost: canAuthorizeTask,
        canDownload: canDownload,
        tasks: state.asyncTasks.asyncTasks[AsyncTasksTypes.IMPORT_BENEFICIARIES],
        authorizedManagerId: state.auth.manager ? state.auth.manager.id : null,
        exampleUploadFile: 'BB Upload Assistance Template.xlsx',
        name: 'File Upload',
        type: AsyncTasksTypes.IMPORT_BENEFICIARIES,
        uploadDescription: 'Upload the Entitlements XLSX.GPG file by clicking the button below.',
        exampleLinkTitle: 'See example import file',
        listView: AsyncTasksListView,
        uploadTaskState: state.uploadTaskState,
        shouldRunDryRun: true,
        mapping: state.appConfig.beneficiariesImportMapping,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AsyncTasksPage);
